// 応募しない求人一覧
import axios from '@/plugins/axios';
import { endpoint } from '@/api/apiConstants';
import { TrnLikeMypageAddRequest } from '@/types/request';

export const postLikeMypageAdd = async (params: TrnLikeMypageAddRequest) => {
  const res = await axios.post(endpoint.addLikeMypage, params);
  return res;
};

export const postLikeMypageBulkRemove = async (params: {orderIds: number[]}) => {
  const res = await axios.post(endpoint.bulkRemoveLikeMypage, params);
  return res;
};